import styled, { keyframes, css } from 'styled-components';
import { MILLISECONDS_PER_SECOND } from 'constants/date';

export const BOUNCE_ANIMATION = {
  COUNT: 3,
  DURATION: 1.5 * MILLISECONDS_PER_SECOND,
};

const bounceAnimation = keyframes`
    0%,
    20%,
    50%,
    80%,
    100% {
        transform: translateY(0)
    }
    40% {
        transform: translateY(-16px)
    }
    60% {
        transform: translateY(-4px)
    }
`;

const fadeIn = keyframes`
  0% {
    opacity: 0;
    bottom: -20px;
  }
  100% {
    opacity: 1;
    bottom: 0;
  }
`;

export const StyledBottomCTAWrapper = styled.div<{ animate: boolean }>`
  ${(props) =>
    props.animate &&
    css`
      animation: ${bounceAnimation};
      animation-duration: ${BOUNCE_ANIMATION.DURATION}ms;
      animation-iteration-count: ${BOUNCE_ANIMATION.COUNT};
    `}
  position: sticky;
  bottom: 0;
  text-align: center;
  padding-bottom: ${({ theme }) => theme.spacing.md};
  animation: ${fadeIn} ease-in-out 150ms;

  svg {
    width: ${({ theme }) => theme.spacing['2Xl']};
    height: ${({ theme }) => theme.spacing['2Xl']};
    color: ${({ theme }) => theme.icon.inverse};
    gap: ${({ theme }) => theme.spacing.md};
    padding: ${({ theme }) => theme.spacing.lg};
    background: ${({ theme }) => theme.background.primary};
    border-radius: ${({ theme }) => theme.borderRadius.round};
    box-sizing: content-box;

    :hover {
      box-shadow: ${({ theme }) => theme.shadow.default};
      cursor: pointer;
      color: ${({ theme }) => theme.icon.inverse};
      background: ${({ theme }) => theme.background.primaryHover};
    }
  }
`;
